module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17u3YI8/tc-custom/9781504072755.jpg?1738254646387",
      "alt": "This image is the cover for the book Blackthorn House, The Dr. Priestley Detective Stories"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blackthorn House, The Dr. Priestley Detective Stories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A man’s car is impounded as a stolen vehicle—but that’s not the worst of it—in this classic British mystery starring a “tartly logical professor” ("), _c('i', [_vm._v("The New York Times")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Kenneth Winslow’s company has sold a car to his nephew, Noel Yewdale, who’s supposed to transport the large, locked chest in it. But before he can get the job done, the police seize the car—saying they think it’s stolen."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When the cops confirm he won’t get the car back, he’s out of luck—but at least they’re willing to help him carry the heavy chest out of the garage where the vehicle has been stored. Unfortunately, Yewdale has an even bigger problem when they pry the chest open to find out why it smells so bad—his uncle’s body is stuffed inside. Superintendent Waghorn will do his best to solve the crime, but he may need some help from Dr. Lancelot Priestley to put the puzzle pieces together . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Rhode, Curtis Evans\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John Rhode was born Cecil John Charles Street in 1884. He was the author of 140 novels under the names John Rhode, Miles Burton, and Cecil Wade before his death in 1964.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media/Open Road\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0